import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import HeatmapExplorer from './HeatmapExplorer.js';
import Search from './prefectures/Search.js';

class SpatialAnalysis extends Component {
  constructor(props) {
    super(props);

    const historyProvince = window.history.state ? window.history.state.province : null;
    const historyPrefecture = window.history.state ? window.history.state.prefecture : null;

    this.state = {
      province: historyProvince || null,
      prefecture: historyPrefecture || null,
      dataPointNames: []
    };
  }

  componentDidMount() {
    fetch('/api/data_exploration/getAllDataPointNames').then((resp) => resp.json())
      .then((respJson) => {
        this.setState({ dataPointNames: respJson });
      });
  }

  updatePrefectures(newState) {
    this.setState(newState);
  }

  render() {
    const { province, prefecture, dataPointNames } = this.state;
    const currentScope = prefecture
      ? 'District heatmap'
      : province
        ? 'Prefecture heatmap'
        : 'Province heatmap';
    const selectedMarketName = prefecture
      ? prefecture.attributes.name
      : province
        ? province.attributes.name
        : 'China overview';

    return (
      <Container fluid className="mt-3 pref-dashboard-shell">
        <div className="pref-page-hero mb-4">
          <div>
            <div className="pref-page-kicker">Spatial Analysis</div>
            <h1 className="pref-page-title mb-2">Map market differences directly.</h1>
            <p className="pref-page-copy mb-0">Analyze value, rank, and geographic concentration through an interactive boundary map workspace.</p>
          </div>
          <div className="pref-page-meta">
            <span className="pref-page-chip">{currentScope}</span>
            <span className="pref-page-chip">{selectedMarketName}</span>
            <span className="pref-page-chip">Heatmap workspace</span>
          </div>
        </div>

        <HeatmapExplorer
          province={province}
          prefecture={prefecture}
          dataPointNames={dataPointNames}
          updatePrefectures={this.updatePrefectures.bind(this)} />

        <Row className="mt-4">
          <Col xl="12">
            <Search
              province={province}
              updatePrefectures={this.updatePrefectures.bind(this)} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default SpatialAnalysis;
